export default __webpack_public_path__ + "static/media/logo-BA-white.a406f311.svg";